// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Route, Routes } from 'react-router-dom';
import Loading from '../components/Loading';
import { useRegistryEntries } from '../hooks/other/useRegistryEntries';
import useProviderService from '../hooks/queries/registry/onboarding/useProviderService';
import useRegistrarService from '../hooks/queries/registry/onboarding/useRegistrarService';
import { CommonUtilitiesLayout } from '../layout/CommonUtilitiesLayout';

export const Registry: React.FC = () => {
  const registrarService = useRegistrarService();
  const providerService = useProviderService();
  const entries = useRegistryEntries();
  const isLoading = registrarService.isLoading || providerService.isLoading;
  if (isLoading) return <Loading />;

  return (
    <CommonUtilitiesLayout entries={entries}>
      <Routes>
        {entries.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Routes>
    </CommonUtilitiesLayout>
  );
};
